(function () {
  'use strict';

  var drawer   = document.getElementById('bl-cart-drawer');
  var overlay  = document.getElementById('bl-overlay');
  var body     = document.getElementById('bl-drawer-body');
  var footer   = document.getElementById('bl-drawer-footer');
  var countEl  = document.getElementById('bl-drawer-count');
  var closeBtn = document.getElementById('bl-drawer-close');

  if (!drawer) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshDrawer();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  closeBtn && closeBtn.addEventListener('click', closeDrawer);
  overlay  && overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function refreshDrawer() {
    body.innerHTML = '<div class="bl-drawer__loading">Loading…</div>';
    footer.style.display = 'none';
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {
        body.innerHTML = '<div class="bl-drawer__loading">Something went wrong.</div>';
      });
  }

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }

  function renderCart(cart) {
    if (countEl) countEl.textContent = cart.item_count;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="bl-drawer__empty">' +
          '<p class="bl-drawer__empty-text">Your cart is empty.</p>' +
          '<a class="bl-drawer__empty-btn" href="/products/better-lash-serum-complete-cure-3-months-bestseller">Discover our serums</a>' +
        '</div>';
      footer.style.display = 'none';
      return;
    }

    var shipIcon = '<svg class="bl-drawer__ship-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
    var shipBar = '<div class="bl-drawer__ship-bar">' + shipIcon + '<strong>Free shipping included</strong></div>';

    var itemsHtml = cart.items.map(function (item) {
      /* Use _pack_image property if available, else item.image */
      var imgSrc = (item.properties && item.properties._pack_image) ? item.properties._pack_image : item.image;
      var img = imgSrc
        ? '<img class="bl-drawer__item-img" src="' + imgSrc + '" alt="' + escHtml(item.title) + '" width="72" height="88" loading="lazy">'
        : '<div class="bl-drawer__item-img-ph"></div>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<span class="bl-drawer__item-variant">' + escHtml(item.variant_title) + '</span>'
        : '';
      return '<div class="bl-drawer__item" data-key="' + item.key + '">' +
        '<a href="' + item.url + '">' + img + '</a>' +
        '<div class="bl-drawer__item-info">' +
          '<a class="bl-drawer__item-name" href="' + item.url + '">' + escHtml(item.product_title) + '</a>' +
          variant +
          '<div class="bl-drawer__item-price">' + money(item.final_price) + '</div>' +
          '<div class="bl-drawer__item-row">' +
            '<div class="bl-drawer__qty">' +
              '<button class="bl-drawer__qty-btn" type="button" data-action="decrease" data-key="' + item.key + '" aria-label="Decrease">−</button>' +
              '<span class="bl-drawer__qty-num">' + item.quantity + '</span>' +
              '<button class="bl-drawer__qty-btn" type="button" data-action="increase" data-key="' + item.key + '" aria-label="Increase">+</button>' +
            '</div>' +
            '<button class="bl-drawer__remove" type="button" data-key="' + item.key + '" aria-label="Remove">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    body.innerHTML = shipBar + itemsHtml;

    footer.innerHTML =
      '<div class="bl-drawer__subtotal-row">' +
        '<span class="bl-drawer__subtotal-label">Subtotal</span>' +
        '<span class="bl-drawer__subtotal-price">' + money(cart.total_price) + '</span>' +
      '</div>' +
      '<p class="bl-drawer__tax-note">Taxes &amp; shipping calculated at checkout</p>' +
      '<a href="/checkout" class="bl-drawer__checkout">Checkout</a>' +
      '<div class="bl-drawer__reassurance">' +
        '<span class="bl-drawer__reas-item"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#8A6070" stroke-width="1.5" stroke-linecap="round"><rect x="3" y="11" width="18" height="11"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>Secure checkout</span>' +
        '<span class="bl-drawer__reas-dot"></span>' +
        '<span class="bl-drawer__reas-item"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#8A6070" stroke-width="1.5" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>30-day guarantee</span>' +
        '<span class="bl-drawer__reas-dot"></span>' +
        '<span class="bl-drawer__reas-item"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#8A6070" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>Free shipping</span>' +
      '</div>';
    footer.style.display = 'block';

    body.querySelectorAll('.bl-drawer__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.key;
        var numEl = btn.closest('.bl-drawer__qty').querySelector('.bl-drawer__qty-num');
        var current = parseInt(numEl.textContent, 10) || 1;
        var next = btn.dataset.action === 'increase' ? current + 1 : Math.max(0, current - 1);
        changeQty(key, next);
      });
    });

    body.querySelectorAll('.bl-drawer__remove').forEach(function (btn) {
      btn.addEventListener('click', function () { changeQty(btn.dataset.key, 0); });
    });
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) { renderCart(cart); })
    .catch(function () { refreshDrawer(); });
  }

  function escHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* ── Public API ── */
  window.blAddToCartAndOpen = function (variantId, properties) {
    if (window.Shopify && window.Shopify.designMode) {
      var btn = document.querySelector('.blp-cta__btn');
      if (btn) {
        var orig = btn.innerHTML;
        btn.innerHTML = '<span>✓ Added to cart</span>';
        btn.style.background = '#C47A8A';
        setTimeout(function () { btn.innerHTML = orig; btn.style.background = ''; }, 2000);
      }
      return;
    }
    var payload = { id: parseInt(variantId, 10), quantity: 1 };
    if (properties && typeof properties === 'object') {
      payload.properties = properties;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function () { openDrawer(); })
    .catch(function () { openDrawer(); });
  };

  window.blOpenCartDrawer = openDrawer;

  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('a[href="/cart"]');
    if (cartLink && !cartLink.closest('#bl-cart-drawer')) {
      if (window.location.pathname !== '/cart') {
        e.preventDefault();
        openDrawer();
      }
    }
  });

})();
